<script setup>
import Hero from "@sections/home/hero.vue";
import Products from "@sections/home/products.vue";
import About from "@sections/home/about.vue";
import Delimiter from "@sections/delimiter.vue";
import Articles from "@sections/home/articles.vue";
import Contact from "@sections/home/contact.vue";
</script>

<template>
  <Hero />
  <Products />
  <About />
  <Delimiter class="md:block hidden" />
  <Articles />
  <Contact />
</template>

<style scoped></style>
